import { usePageControls } from '~/api/hooks/useCharts'
import {
  PRESET_OPTIONS,
  toAbsoluteTimeframes,
  toSurfacedRollingTimeframes,
} from '~/components/Filters/TimeframeSelect'
import { resolveTimeframeLabel } from '~/components/Charts/chrome/chartChrome'
import type { ReviewPageState } from './useReviewPageState'

const PRESET_LABELS: Record<string, string> = Object.fromEntries(
  PRESET_OPTIONS.map((p) => [p.value, p.label]),
)

/** Display label of the page's MAIN window: preset label, frame/campaign label on a bounds
 *  match (TimeframeSelect's selected-option rule), else the ISO date range. */
export function useTimeframeLabel(state: ReviewPageState): string {
  const controls = usePageControls(state.factTable)
  // Campaigns C1 (spec §4): a reconciled campaign identity names the window by its label (id-based,
  // exact) — it wins over bounds-matching. usePageControls stays called before this early return so
  // hook order is stable.
  if (state.campaign) return state.campaign.label
  return resolveTimeframeLabel({
    preset: state.timeframePreset.preset,
    presetLabels: PRESET_LABELS,
    fromIso: state.fromIso,
    toIso: state.toIso,
    absoluteOptions: [
      ...toAbsoluteTimeframes(controls.data?.timeframe_frames?.items),
      ...toSurfacedRollingTimeframes(controls.data?.timeframe_rolling?.items),
      ...toAbsoluteTimeframes(controls.data?.campaign_timeslots?.items),
    ],
  })
}
